export default "__VITE_ASSET__fb049a99__"